import BoxToFlex from './BoxToFlex';
export default BoxToFlex;
//# sourceMappingURL=index.js.map